// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1EIuB","list":"PatternAutocomplete_list__9KKro"};